// QtyBeforeSuspension.tsx
// 中間実績数入力モーダル
import React, { useEffect } from 'react';
import RippleButton from '../ui/rippleButton'
import  './QtyBeforeSuspension.css';

interface QtyBeforeSuspensionProps {
    onClose: (qty:string[]) => void;
    suspensionRows: any[];
  }

const QtyBeforeSuspension: React.FC<QtyBeforeSuspensionProps> = ({suspensionRows, onClose}) => {
    const [index, setIndex] = React.useState(0);
    const [currentPoDescNum, setCurrentPoDescNum] = React.useState("");
    const [qty, setQty] = React.useState<string>('');
    const [qtys, setQtys] = React.useState<string[]>([]);

    useEffect(() => {
        if (suspensionRows.length > 0) {
            setCurrentPoDescNum(suspensionRows[index].po_desc_num);
        }
    }, [suspensionRows, index])

    // 変更前機械コードの変更を検知
    const handlerRegist = () => {
        if (Number.isNaN(Number(qty)) || qty === '') {
            alert("数値を入力してください");
            return;
        }
        if (Number(qty) === suspensionRows[index].current_qty) {
            alert("現計画数と実績数が同数の場合は終了してください。");
            return;
        }
        if (Number(qty) > suspensionRows[index].current_qty) {
            alert("現計画数よりも入力枚数が多いです");
            return;
        }
        const newIndex = index + 1;
        const newQty = [...qtys];
        newQty.push(qty);
        setQtys(newQty);
        setIndex( (index + 1));
        console.log(newIndex);
        console.log(suspensionRows.length);
        if (newIndex === suspensionRows.length) {
            onClose(newQty);
            setIndex(0); 
            return;
        } else {
            // 次の入力へ
            setCurrentPoDescNum(suspensionRows[newIndex].po_desc_num);
            setQty("");
        }
    }

    return (
        <div className='qty-before-suspension-container'>
            <div className='qty-before-suspension-title-item'>
                <img
                    src="images/rec-pause.svg"
                    alt="Processes Pause"
                    className="icon myShadow suspension-qty-icon"
                />
                <h2>中間実績数</h2>
            </div>
            <div className='po-desc-label-item'>
                受注No
            </div>
            <div className='po-desc-num-item'>
                {currentPoDescNum}
            </div>
            <div className='qty-label-item'>
                実績枚数
            </div>
            <div className='qty-item'>
                <input
                    type="text"
                    value={qty}
                    onChange={(e) => setQty(e.target.value)}
                />
                枚（セット）
            </div>
            <div className='suspension-qty-regist-button-item'>
                <RippleButton
                    width={'180px'}
                    heihgt={'50px'}
                    borderRadius={'8px'}
                    onClick={handlerRegist}
                    effectSize={160}
                    className='bk-secondary'
                >
                    <span className="children">登録</span>
                </RippleButton>
            </div>
        </div>
    )
}

export default QtyBeforeSuspension;